import Vue from 'vue';
import mixin from './mixin.js';

require(`./assets/${process.env.VUE_APP_BRAND}/scss/_fonts.scss`);

window.startupTSVue = new Date().getTime();
Vue.prototype.$initialData = window.initialData;

new Vue({
	el: '#app',
	mixins: [mixin],
	components: {
		'hp-app': require('./App.vue').default
	}
});
